export const detectDuplicateElements = (arr: string[]): boolean => {
  const filtered = arr?.filter(serial => !!serial);
  const uniqueElements = new Set(filtered);
  return uniqueElements?.size !== filtered?.length;
};